import React, { Component } from 'react'
import { connect } from 'react-redux'
import style from './style'
import classnames from 'classnames'
import { IonIcon } from 'controls'
import { image } from 'services'
import Link from 'next/link'
import Notification from './Notification'
import store from 'services/store'
import { bindActionCreators } from 'redux'
import { NotificationActionCreators } from 'app/reducers/NotificationRedux'
import {
  MAILCOW_SSO_URL
} from 'services/config'

import { checkFeatureFlag } from 'config'

class NotificationMenu extends Component {
  constructor(props) {
    super(props)
    this.state = {
      menuReady: false,
      menuOpen: false
    }
  }

  UNSAFE_componentWillMount() {
    this.props.actions.getNotifications()

    this.setState({
      menuReady: true
    })
  }

  toggleMenu = () => {
    const { unreadNotifications, badge } = this.props
    const lastNotification = unreadNotifications[0]

    if (badge && lastNotification) {
      this.props.actions.newNotification(
        lastNotification.id,
        lastNotification.createdAt
      )
    }

    this.props.actions.hideBadge()
    this.setState({ menuOpen: !this.state.menuOpen })
  }

  renderHeader = () => {
    const { notifications, unreadNotifications } = this.props
    if (notifications.length > 0) {
      return (
        <div className="hideOnMobile" style={{ display: 'flex' }}>
          Notificaciones
          <span className="badgeright hideOnMobile">
            {unreadNotifications.length}
          </span>
        </div>
      )
    } else {
      return <div className="hideOnMobile">Ninguna notificación</div>
    }
  }

  render() {
    const { notifications, unreadNotifications, badge } = this.props
    const { menuReady, menuOpen } = this.state
    const h = menuOpen ? 'auto' : 0

    const menuStyle = {
      display: menuReady ? 'block' : 'none',
      right: 0
    }

    let notificationList = null
    if (notifications.length > 0) {
      notificationList = notifications
        .slice(0, 3)
        .map((n, i) => <Notification notification={n} index={i} key={n.id} />)
    }

    return (
      <div className="notification-menu-container">
        <div className="notification-menu-label" onClick={this.toggleMenu}>
          <IonIcon
            className={classnames(
              { badgeleft: badge },
              'hideOnMobile',
              'icon-notification'
            )}
            data-badge={unreadNotifications.length}
            size="small"
            icon="md-notifications"
          />
        </div>
        <div
          className="notification-menu-label hideOnLarge icon-notification"
          onClick={this.toggleMenu}
        >
          <IonIcon
            className={classnames({ badgeleft: badge }, 'hideOnLarge')}
            data-badge={unreadNotifications.length}
            size="medium"
            icon="md-notifications"
          />
        </div>
        <div
          onClick={this.toggleMenu}
          className="notification-menu-overlay"
          style={{ display: menuOpen ? 'block' : 'none' }}
        />
        <div
          style={menuStyle}
          className={classnames('notification-menu-content', {
            collapsed: menuReady && !menuOpen
          })}
        >
          <div className="notification-menu-header">{this.renderHeader()}</div>

          {notificationList}
          {checkFeatureFlag('show-on-hl-integration') && (
            <Link href="/dashboard/calendar">
              <a className="secondary-menu-item hideOnLarge">
                <IonIcon
                  className="hideOnLarge"
                  size="small"
                  icon="md-calendar"
                />
                Calendario
              </a>
            </Link>
          )}
          {MAILCOW_SSO_URL && (
            <a
              href={MAILCOW_SSO_URL}
              className="secondary-menu-item hideOnLarge"
              target="_blank"
              rel="noopener noreferrer"
            >
              <IonIcon
                className="hideOnLarge"
                size="small"
                icon="md-mail-open"
              />
              Correo
            </a>
          )}
          <Link href="/dashboard/notifications">
            <a className="secondary-menu-item hideOnLarge">
              <IonIcon
                className={classnames({ badgeleft: badge }, 'hideOnLarge')}
                data-badge={unreadNotifications.length}
                size="small"
                icon="md-notifications"
              />
              Notificaciones
            </a>
          </Link>

          {notifications.length > 3 && (
            <div className="notification-more">
              <Link href="/dashboard/notifications">
                <a>Más notificaciones</a>
              </Link>
            </div>
          )}
        </div>
        <style jsx>
          {style}
        </style>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  profile: state.auth.profile,
  notifications: state.notification.notifications,
  unreadNotifications: state.notification.unreadNotifications,
  notification: state.notification,
  loading: state.notification.loading,
  badge: state.notification.badge
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      getNotifications: NotificationActionCreators.getNotificationsRequest,
      newNotification: NotificationActionCreators.newNotification,
      addNotification: NotificationActionCreators.addNotification,
      hideBadge: NotificationActionCreators.hideBadge
    },
    dispatch
  )
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NotificationMenu)
